import { roles } from '@/config/roles'

const routes = [
  {
    name: 'ContentHistory',
    path: '/history_of_content',
    component: () => import('@/views/content/history/index'),
    meta: {
      roles: [roles.curator]
    }
  },
  {
    name: 'ContentEventHistory',
    path: '/history_of_content/event/:id',
    component: () => import('@/views/content/history/Event'),
    meta: {
      roles: [roles.curator]
    }
  },
  {
    name: 'ContentSingleNewsHistory',
    path: '/history_of_content/news/:id',
    component: () => import('@/views/content/history/News'),
    meta: {
      roles: [roles.curator]
    }
  },
  {
    name: 'ContentClassHistory',
    path: '/history_of_content/class/:id',
    component: () => import('@/views/content/history/Class'),
    meta: {
      roles: [roles.curator]
    }
  },
  {
    name: 'ContentPartnerHistory',
    path: '/history_of_content/partner/:id',
    component: () => import('@/views/content/history/Partner'),
    meta: {
      roles: [roles.curator]
    }
  },
  {
    name: 'ContentCourseHistory',
    path: '/history_of_content/course/:id',
    component: () => import('@/views/content/history/Course'),
    meta: {
      roles: [roles.curator]
    }
  },
  {
    name: 'ContentTrainingHistory',
    path: '/history_of_content/course/:id',
    component: () => import('@/views/content/history/Training'),
    meta: {
      roles: [roles.curator]
    }
  },
  {
    name: 'Statistics',
    path: '/statistics',
    component: () => import('@/views/Statistics'),
    meta: {
      roles: [roles.curator]
    }
  }
]
export default routes
